module.exports = __webpack_public_path__ + "media/svg/mf-8bbb4186.svg";